import unlockedFeaturesDataset from "../datasets/unlocked_features_dataset";

export const getUnlockedFeatureCriteria = (featureName, featureLevel, featureStatus) =>{

    let featureCriteria = {};
    let featureFound = false;
    let featureEarnedLevel = 0;
    let currentLevel = 0;
    const selectFeatureArr = unlockedFeaturesDataset.filter(elem => elem.featureName === featureName);
    for (let i=0; i<selectFeatureArr.length; i++){
        const unlockedFeatureCriteria = selectFeatureArr[i];
        if (featureName === unlockedFeatureCriteria.featureName) {
            if (featureLevel === unlockedFeatureCriteria.level && featureStatus === "active"){
                currentLevel = featureLevel;
            }
            if ((featureLevel === unlockedFeatureCriteria.level && featureStatus !== "active") ||
                    featureLevel < unlockedFeatureCriteria.level) {
                featureCriteria = unlockedFeatureCriteria;
                featureFound = true;
                featureEarnedLevel = unlockedFeatureCriteria.level;
                break;
            }
        }
    }
    const returnObj = {featureCriteria: featureCriteria, featureFound: featureFound, 
        levelEarned: featureEarnedLevel, currentLevel: currentLevel }
    return returnObj;
}
export default getUnlockedFeatureCriteria;
